import { render, staticRenderFns } from "./SelectCategoryStep.vue?vue&type=template&id=0483f8ba&scoped=true&"
import script from "./SelectCategoryStep.vue?vue&type=script&lang=js&"
export * from "./SelectCategoryStep.vue?vue&type=script&lang=js&"
import style0 from "./SelectCategoryStep.vue?vue&type=style&index=0&id=0483f8ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0483f8ba",
  null
  
)

export default component.exports